import { render, staticRenderFns } from "./coder-picker.vue?vue&type=template&id=6483fe1a"
import script from "./coder-picker.vue?vue&type=script&lang=js"
export * from "./coder-picker.vue?vue&type=script&lang=js"
import style0 from "./coder-picker.vue?vue&type=style&index=0&id=6483fe1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports